import {
  anyValidator,
  validateAlpha,
  validateAlphaNumeric,
  validateBirthDate,
  validateCURP,
  validateEmail,
  validateNumeric,
  validateNumericWithZero,
  validatePhoneNumber,
  validatePropertyNumber,
  validateRFC,
  validateStreet,
  validateUrl,
  validateZipCode,
} from "../generalValidators.ts";

export const tenantFormValidators = {
  first_name: validateAlpha,
  second_name: validateAlpha,
  first_last_name: validateAlpha,
  second_last_name: validateAlpha,
  country: anyValidator,
  city: validateAlpha,
  state: validateAlpha,
  birth_date: validateBirthDate,
  rfc: validateRFC,
  curp: validateCURP,
  street: validateStreet,
  exterior_number: validatePropertyNumber,
  interior_number: validatePropertyNumber,
  neighborhood: validateAlphaNumeric,
  postal_code: validateZipCode,
  municipality: validateAlpha,
  current_state: validateAlpha,
  phone: validatePhoneNumber,
  people_in_house: validateNumeric,
  people_depend: validateNumericWithZero,
  last_landlord_name: validateAlpha,
  last_landlord_email: validateEmail,
  last_landlord_phone: validatePhoneNumber,
  rent_amount: validateNumeric,
  cellphone: validatePhoneNumber,
  company_name: validateAlphaNumeric,
  company_website: validateUrl,
  job_seniority: anyValidator,
  company_turn: validateAlpha,
  company_street: validateStreet,
  company_exterior_number: validatePropertyNumber,
  company_interior_number: validatePropertyNumber,
  company_neighborhood: validateAlphaNumeric,
  company_municipality: validateAlpha,
  company_postal_code: validateZipCode,
  job_reference_name: validateAlpha,
  job_reference_phone: validatePhoneNumber,
  monthly_expenses: validateNumeric,
  email: validateEmail,
  job_reference_email: validateEmail,
};
